<template>
    <div class="logo-picker">
        <ImageSelector class="logo-picker__input" label="Logo" v-model="image" show-image @showMediaLibrary="showMediaLibrary" />
            <v-img :src="image" class="logo-picker__preview" height="150" width="300" contain>
                <template #placeholder>
                    <div class="logo-preview__placeholder">
                        Logo will show after upload
                    </div>
                </template>
            </v-img>
        <v-dialog v-model="showMediaLib" width="75%">
            <MediaLibrary @usefile="useMediaFile" />
        </v-dialog>
    </div>
</template>

<script>
import ImageSelector from "@/CMS/editor/components/ImageSelector";
import MediaLibrary from "@/CMS/editor/mediaLibrary.vue";

export default {
    components: { ImageSelector, MediaLibrary },

    props: {
        value: { type: String },
    },

    data() {
        return {
            showMediaLib: false,
        };
    },

    computed: {
        image: {
            get() {
                return this.$props.value;
            },
            set(v) {
                this.$emit("input", v);
            },
        },
    },

    methods: {
        showMediaLibrary() {
            this.showMediaLib = true;
        },

        useMediaFile(fileUrl) {
            this.image = fileUrl;
            this.showMediaLib = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.logo-picker {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;

    &__input {
        flex: 2;
        margin-right: 2rem;
    }

    &__preview {
        width: 300px;
        background: rgba(0, 0, 0, 0.1);
    }
}

.logo-preview {
    &__placeholder {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background: rgba(0, 0, 0,0.1);
        border: 1px solid #707070;
        background-size: 300px auto;
    }
}
</style>
